// removed by extract-text-webpack-plugin
module.exports = {"close":"_5nI6R7CoYla4MUj-rNwzG","component":"z-fa2ky0TG1pA1Pf7wT8n","modalContent":"_163hRxC--Xd2KOCoimp_19","headerImg":"_35avtq6v4Q8OQ3_S3mBSqX","header":"_2sWkg1DnDIFZBqW6ykTlG2","title":"_3Sy-BSTiDA8Awx0oamVWGH","tail":"_34tZoQ1DnDnHL8rGrB1AVX","item":"_1CW15K_EHfQ3MP9xvTaG8r","checkbox":"_1-Qdxuq_Vce6La_XT5SDPe","groupHeader":"fjIf-61-8wBHvepMbN3RE","inputRadio":"_2k-XG9MuaYOXxuhrUnQiWk","spana":"m_daxAAx5KrtkuKic0zrT","icon_sj_a":"YuXbtf6whxOgBgfG-CezZ","divDe":"a91eNdrLCgd5Afm5kodn-","zhuan_a":"_3lZthWEdz1ZL9BA25_hnYv","zhuan":"_1Q6rDuLqFaArrfuAlxUsPO"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/PackagingModal/PackagingModal.scss
 ** module id = 399
 ** module chunks = 0
 **/